export enum LoginTypeButton {
  DEFAULT = "default",
  HOME_BIG = "homeBig",
  HOME_CIRCLE = "homeCircle",
}

export enum DatadogProviderEnablingMessage {
  UNKNOWN_PROVIDER = "unknown auth provider:",
}
